import { render } from "./ConstraPage.vue?vue&type=template&id=845622ca&scoped=true"
import script from "./ConstraPage.vue?vue&type=script&lang=js"
export * from "./ConstraPage.vue?vue&type=script&lang=js"

import "./ConstraPage.vue?vue&type=style&index=0&id=845622ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845622ca"]])

export default __exports__